import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 18"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M20.35 3H1.65C.739 3 0 2.328 0 1.5S.739 0 1.65 0h18.7C21.261 0 22 .672 22 1.5S21.261 3 20.35 3ZM20.35 10.5H1.65C.739 10.5 0 9.828 0 9s.739-1.5 1.65-1.5h18.7c.911 0 1.65.672 1.65 1.5s-.739 1.5-1.65 1.5ZM20.35 18H1.65C.739 18 0 17.328 0 16.5S.739 15 1.65 15h18.7c.911 0 1.65.672 1.65 1.5s-.739 1.5-1.65 1.5Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }